export default {
    setList(state, orders) {
        state.orders = orders;
    }
}